import { render, staticRenderFns } from "./app.vue?vue&type=template&id=c61fc028&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=c61fc028&prod&scoped=true&lang=css"
import style1 from "./app.vue?vue&type=style&index=1&id=c61fc028&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61fc028",
  null
  
)

export default component.exports